export default {
  isRefinance: (model) => {
    try {
      return model.transactionType.name === 'refinance';
    } catch (_) {
      return false;
    }
  },

  displayRepairs: (deal) => {
    if (deal.transactionType && deal.dealType) {
      return !(
        deal.transactionType.name === 'purchase' &&
        deal.dealType.name === 'non_rehab_bridge'
      );
    }

    return true;
  },

  rehabOrOther: (model) => {
    try {
      return ['rehab_fix_and_flip', 'other'].includes(model.dealType.name);
    } catch (_) {
      return false;
    }
  },

  needsRepair: (model) => {
    try {
      return ['rehab_fix_and_flip', 'new_construction', 'other'].includes(model.dealType.name);
    } catch (_) {
      return false;
    }
  },

  shouldDisplayAdditionalField: (model) => {
    if (!model.dealType) { return false; }

    const dealType = model.dealType.name;
    return (
      model &&
      (
        dealType === 'new_construction' ||
        (
          ['rehab_fix_and_flip', 'other'].includes(dealType) &&
          model.propertyRepair.hasAdditionalSqFt === true
        )
      )
    );
  },

  notRefinanceBridge: (model) => {
    if (!model.dealType) { return false; }

    return (
      model &&
      model.transactionType.name === 'refinance' &&
      model.dealType.name !== 'non_rehab_bridge'
    );
  },

  isShortSale: purchaseModel => purchaseModel.type === 'short_sale',
  hasShortSaleApprovalFile: purchaseModel => (
    purchaseModel.type === 'short_sale' &&
    purchaseModel.shortSaleApproval === true
  ),
  hasSecondLien: purchaseModel => (
    purchaseModel.type === 'short_sale' &&
    purchaseModel.hasSecondLien === true
  ),
  hasSecondLienApproval: purchaseModel => (
    purchaseModel.type === 'short_sale' &&
    purchaseModel.hasSecondLienApproval === true
  ),
};



// WEBPACK FOOTER //
// ./src/components/new_deal/libs/helper.js